import React, { useEffect, useState } from 'react';
import { Divider } from 'antd';
import {
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  Linkedin as LinkedinIcon,
} from 'react-feather';
import TextLogo from 'components/Brand/TextLogo';
import { Button, IconButton, Typography } from 'ui-kit';
import './Footer.scss';

const currentYear = new Date().getFullYear();
const hostcoAbout = `The Host Co is a retail solution designed to help hosts sell their
products and services in short-term rental spaces. Simply create a store, personalize it,
and begin selling instantly.`;

type Props = {
  isEnterprise?: boolean;
  about?: string;
};

export function useInIframe() {
  const [inIframe, setInIframe] = useState(false);

  useEffect(() => {
    let isInIframe = false;
    try {
      isInIframe = window.self !== window.top;
    } catch (e) {
      isInIframe = true;
    }
    setInIframe(isInIframe);
  }, []);

  return inIframe;
}

export default function Footer({ isEnterprise = false, about }: Props) {
  const inIFrame = useInIframe();

  return (
    <footer className="Footer">
      {inIFrame ? (
        <div className="Footer-container">
          <div className="Footer-container__content">
            <div className="Footer-container__content-socials">
              {isEnterprise && (
                <div className="Footer-container__enterprise-block">
                  <Typography variant="subtitle2" className="Footer-container__enterprise-subtitle">
                    Powered By
                  </Typography>
                </div>
              )}
              <TextLogo
                className=""
                onClick={() => window.open('https://www.thehost.co', '_blank')}
                style={{ cursor: 'pointer' }}
              />
              <h6 className="Footer-container__logo-subtitle">
                Powering guest experiences beyond the nightly rate.
              </h6>
              {inIFrame && (
                <div className="Footer-container__content-iframedLinks">
                  <Button href="https://www.thehost.co/guest-help-returns" color="textGray">
                    [Help & Returns]
                  </Button>{' '}
                  &middot;
                  <Button href="https://www.thehost.co/terms-conditions" color="textGray">
                    [FAQ]
                  </Button>
                  &middot;
                  <Button href="https://www.thehost.co/privacy-policy" color="textGray">
                    [Privacy Policy]
                  </Button>
                  &middot;
                  <Button href="mailto:support@thehost.co" color="textGray">
                    [Contact Us]
                  </Button>
                </div>
              )}
            </div>
            {!inIFrame && isEnterprise && (
              <div className="Footer-container__content-aboutUs">
                <Typography variant="subtitle1" className="Footer-container__content-aboutUs-title">
                  About Us
                </Typography>
                <Typography variant="body2">
                  {isEnterprise && about ? about : hostcoAbout}
                </Typography>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="Footer-container">
          <div className="Footer-container__content">
            <div className="Footer-container__content-socials">
              {isEnterprise && (
                <div className="Footer-container__enterprise-block">
                  <Typography variant="subtitle2" className="Footer-container__enterprise-subtitle">
                    Powered By
                  </Typography>
                </div>
              )}
              <TextLogo className="" />
              <div className="Footer_icons">
                <IconButton
                  variant="text"
                  color="textGray"
                  href="https://www.instagram.com/thehostcompany/"
                >
                  <InstagramIcon />
                </IconButton>
                <IconButton
                  variant="text"
                  color="textGray"
                  href="https://www.facebook.com/TheHostCompany/"
                >
                  <FacebookIcon />
                </IconButton>
                <IconButton
                  variant="text"
                  color="textGray"
                  href="https://www.linkedin.com/company/the-host-co"
                >
                  <LinkedinIcon />
                </IconButton>
              </div>
            </div>

            <div className="Footer-container__content-aboutUs">
              <Typography variant="subtitle1" className="Footer-container__content-aboutUs-title">
                About Us
              </Typography>
              <Typography variant="body2">{isEnterprise && about ? about : hostcoAbout}</Typography>
            </div>

            <div className="Footer-container__content-links">
              <Button
                href="https://thehostcohelp.zendesk.com/hc/en-us/categories/15225750829325-Best-Practices"
                target="_blank"
                color="textGray"
              >
                Best Practices
              </Button>
              <Button href="https://www.thehost.co/guest-help-returns" color="textGray">
                Help + Returns
              </Button>
              <Button href="https://www.thehost.co/terms-conditions" color="textGray">
                Terms & Conditions
              </Button>
              <Button href="https://www.thehost.co/privacy-policy" color="textGray">
                Privacy Policy
              </Button>
              <Button href="mailto:support@thehost.co" color="textGray">
                Contact Us
              </Button>
            </div>
          </div>
          <div>
            <Divider />
            <Typography variant="body2" color="textGray">
              Copyright © {currentYear}
            </Typography>
          </div>
        </div>
      )}
    </footer>
  );
}
